// extracted by css-extract-rspack-plugin
export default {"subheader":"I7LJg9ERrag2NaII","actions":"oiQSBr5a6LIIVCel","subPage":"N5b5k8ouYbGsOZ6v"};